// project import
import pages from './pages';
import dashboard from './dashboard';
import accounts from './accounts';
import sales from './sales';
import elections from './elections';
import finance from './finance';
import settings from './settings';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, accounts, elections, finance, settings]
};

export default menuItems;
